<script setup>
import { provide, ref, inject, onMounted } from 'vue';
import { __, updateURL, requestPlanCTP } from '@/utils';
import addNumber from './fragments/addNumber.vue';

const availableMsisdns = ref({});
const { setPlans, plans } = inject('step');
const setAvailableMsisdns = (data) => availableMsisdns.value = data;

updateURL('#step1');

const fetchPlansCTP = async () => {
	if(plans.length) return;

    try {
        const response = await requestPlanCTP();
        setPlans(response);
    } catch (error) {
        console.error('Error fetching plans:', error);
    }
};

provide('step1', {
	availableMsisdns,
	setAvailableMsisdns
});

onMounted(() => {
	fetchPlansCTP();
});

</script>
<template>
		<div class="form__group">
			<header class="form__head">
				<h2>
					{{ __('Select a number') }}
				</h2>
			</header><!-- /.form__head-->

			<addNumber />
		</div><!-- /.form__group -->
</template>